import { css } from '@emotion/core';

const logoStyle = {
  img: css`
    width: auto;
    height: 29px;
  `,
};

export default logoStyle;
